import { BaseResponseMapper } from './Base'
import {
  Position,
  PositionData,
  PositionDataDnet,
  PositionDnet,
} from '@/domain/entities/Position'
import { AxiosResponse } from 'axios'

export class PositionDataMapper extends BaseResponseMapper {
  public convertFromApi(result: AxiosResponse<any>): Position {
    const { data } = result
    return new Position(
      data.success,
      data.message,
      data.data.map(
        (val) => new PositionData(val.id, val.code, val.description, 'SFID')
      )
    )
  }
  public convertFromApiDnet(result: AxiosResponse<any>): PositionDnet {
    const { data } = result
    return new PositionDnet(
      data.success,
      data.message,
      data.data.map(
        (val) => new PositionDataDnet(val.id, val.code, val.description, 'DNET')
      )
    )
  }
}
